import { SET_LOCATION_GROUPS } from './chunk-EMTYXPW7.mjs';
import { __export } from './chunk-T36PI2YV.mjs';

// src/state/locations/actions.ts
var actions_exports = {};
__export(actions_exports, {
  setLocationGroupsOnState: () => setLocationGroupsOnState
});
var setLocationGroupsOnState = (payload) => ({
  type: SET_LOCATION_GROUPS,
  payload
});

export { actions_exports, setLocationGroupsOnState };
